import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import * as api from "@/api";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async getCompanyList(ctx, params) {
    try {
      const state = ctx.rootState;
      params.limit = params.limit || 20;
      params.offset = state.pages.plan.companies.length;
      const oldParams = Object.assign(
        {},
        state.pages.plan.competitorSearchParams
      );
      const response = await api.getCompanyList(params);
      const responseCompanies = response.data.companies;
      const stateCompanies = state.pages.plan.companies;
      const companies = stateCompanies
        ? stateCompanies.concat(responseCompanies)
        : responseCompanies;

      // NOTE: 複数のRequestした際、最後のRequestか否かをパラメータで判定
      // axiosのRequestをキャンセルできるのであれば、そちらのほうが好ましい
      const currentParams = state.pages.plan.competitorSearchParams;
      const requestParams = params;
      const jsonCurrentParams = JSON.stringify(currentParams);
      const jsonRequestParams = JSON.stringify(requestParams);
      const jsonOldParams = JSON.stringify(oldParams);
      if (
        (jsonCurrentParams !== jsonOldParams && !requestParams.offset) ||
        (jsonCurrentParams !== jsonRequestParams &&
          jsonRequestParams === jsonOldParams) ||
        (jsonCurrentParams === jsonRequestParams && !requestParams.offset)
      ) {
        return;
      }

      ctx.commit("getCompanyListSuccess", {
        companiesTotal: response.data.total,
        companies: companies
      });
      return;
    } catch (error) {
      throw error;
    }
  },
  async getUniversityList(ctx, params) {
    try {
      const response = await api.getUniversityList(params);
      ctx.commit("getUniversityListSuccess", {
        universities: response.data.universities
      });
    } catch (error) {
      throw error;
    }
  },
  async updateCompetitorsOrder(ctx, { oldIndex, ...params }) {
    if (!ctx.state.applicationPlan) return;

    const newIndex = params.company.sort_order_position;

    if (newIndex === oldIndex) {
      return;
    }

    ctx.commit("moveCompetitorEmbeddedIndex", { oldIndex, newIndex });
    try {
      await api.updateCompetitor(params);
    } catch (error) {
      ctx.commit("moveCompetitorEmbeddedIndex", {
        oldIndex: newIndex,
        newIndex: oldIndex
      });
      throw error;
    }
  },
  async updateUniversitiesOrder(ctx, { oldIndex, ...params }) {
    if (!ctx.state.applicationPlan) return;

    const newIndex = params.university.sort_order_position;

    if (newIndex === undefined || newIndex === oldIndex) {
      return;
    }

    ctx.commit("moveStudentEmbeddedIndex", { oldIndex, newIndex });
    try {
      await api.updateUniversity(params);
    } catch (error) {
      ctx.commit("moveStudentEmbeddedIndex", {
        oldIndex: newIndex,
        newIndex: oldIndex
      });
      throw error;
    }
  }
};

export default actions;
